module.exports = __webpack_public_path__ + "img/key-old.56d3db97.svg";